<template>
  <v-btn
    class="elevation-0 mx-2"
    color="#CC3300"
    @click="search"
    :loading="loading"
    depressed
    :disabled="disable"
    style="color: white"
  >
    <v-icon class="mr-2" style="color: white">picture_as_pdf</v-icon>
    Gerar PDF
  </v-btn>
</template>

<script>
  // import * as XLSX from "xlsx";
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import logoImage from '@/assets/images/logo.png';
import { mapState } from 'vuex'
import dayjs from 'dayjs';
import { VUE_APP_NAME } from '@/commons/config'

export default {
  name:"GeneratePDF",
  props:{
    head:{type:Array,
      default:  function () {
      return [];
    }},
    itens: {type:Array,
      default:  function () {
      return [];
    }},
    itemsPerPage: {type: Number, default: 4},
    title: {type: String, default: ""},
    reportData: {
      type: Function,
      required: false,
    },
    disable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
    }),
  },
  data: () => ({ loading: false }),
  methods:{
    gerarPDF(json){
      const data = json || this.itens

      const headers = [].concat(...this.head.map(h => [h.text]));
      this.removeActions(headers)

      const generalDate = dayjs().format("DD/MM/YYYY");
      const generalHour = dayjs().format("HH:mm:ss");

      const itemsPerPage = this.itemsPerPage;
      const totalPages = Math.ceil(data.length / itemsPerPage);

      const pdfDoc = new jsPDF({
        orientation: 'landscape',
      });

      pdfDoc.addImage(logoImage, 'PNG', 15, 12, 60, 15)
      pdfDoc.setFontSize(18);
      pdfDoc.text(``,145,23)

      for (let currentPage = 0; currentPage <= totalPages; currentPage++) {
        const startIndex = currentPage * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const dataSlice = data.slice(startIndex, endIndex);
        // Add a new page for each iteration
        if (currentPage > 0 &&  dataSlice.length > 0) {
          pdfDoc.addPage();
        }

        if( dataSlice.length > 0){
          const config = {
            y:80,
            margin: {left:10, top:33,},
            head : [headers],
            didDrawPage: function (data) {
              if (dataSlice.length > 0) {
                data.table.head = []
                data.margin = {left:10, top:0,}
                pdfDoc.setFontSize(8);
                pdfDoc.text(` Relatório foi gerado em ${generalDate} as ${generalHour}, por meio do sistema ${VUE_APP_NAME}`,150,208)

              }

            },


            body: dataSlice.map(obj => Object.values(obj)),

          }

          pdfDoc.autoTable(config);
        }

      }

      pdfDoc.save(`${this.title} ${generalDate} - ${generalHour} .pdf`);

    },
    async search() {
      this.loading = true
      try {
        const json = await this.reportData()
        this.loading = false
        this.gerarPDF(json)
      } catch (error) {
        this.loading = false
      }
    },
    removeActions(headers){
      var index = headers.indexOf("Ações");
      if(index == -1) return ;
      return headers.splice(index, 1)
    }
  }
}
</script>
